import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=6d199144&scoped=true&lang=pug&"
import script from "./BaseButton.vue?vue&type=script&lang=js&"
export * from "./BaseButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseButton.scss?vue&type=style&index=0&id=6d199144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d199144",
  null
  
)

export default component.exports